var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMoonLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2419 5.04188C20.5396 5.00467 20.7814 4.78141 20.8558 4.48374C20.9303 4.20467 20.8372 3.88839 20.614 3.70234C18.6791 2.06513 16.2047 1.1535 13.6558 1.1535C7.68374 1.1535 2.80933 6.00932 2.80933 12C2.80933 17.9907 7.66514 22.8465 13.6558 22.8465C16.3349 22.8465 18.921 21.8419 20.9303 20.0372C21.1535 19.8326 21.2279 19.5163 21.1535 19.2372C21.0791 18.9582 20.8186 18.7535 20.521 18.7163C17.0605 18.307 14.4372 15.3675 14.4372 11.8698C14.4186 8.42792 16.8744 5.56281 20.2419 5.04188ZM12.893 11.8512C12.893 15.5349 15.2744 18.7163 18.6605 19.8512C17.1721 20.8 15.4419 21.3209 13.6558 21.3209C8.52095 21.3209 4.35351 17.1349 4.35351 12.0186C4.35351 6.90234 8.53956 2.71629 13.6558 2.71629C15.3117 2.71629 16.9303 3.16281 18.3442 3.98141C15.107 5.17211 12.893 8.26048 12.893 11.8512Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoonLight);
export default __webpack_public_path__ + "static/media/moonLight.bc3db503b54e560a356eab359bd0d852.svg";
export { ForwardRef as ReactComponent };